import { Box } from "@mui/material";
import CustomDialog from "components/CustomDialog";
import CabinCreateInWizardForm from "pages/vending/machine/create/CabinCreateInWizardForm";
import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { clearMachineState } from "store/reducers/vending";

const AddMoreCabins = ({ machine, open, handleClose }) => {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(clearMachineState());
  }, [dispatch, open]);
  return (
    <CustomDialog
      fullScreen={false}
      open={open}
      handleClose={handleClose}
      heading="Add more cabins"
    >
      <Box paddingX={2}>
        <CabinCreateInWizardForm machine={machine} fullGrid={true} />
      </Box>
    </CustomDialog>
  );
};

export default AddMoreCabins;
